import React from 'react'
import { Tooltip } from 'antd';
import './indicator.css'
import {Link} from 'react-scroll'


function Indicator() {
    return (
        <div className="indi-main">
        <div className="timeline">
             <ul className="indicator-ul">
             <li className="indicator-li">
                    <Tooltip placement="left" title="Top">
                        <Link to="menuu"  smooth={true} duration={1000}>
                          <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                       </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Educational Solutions">
                        <Link to="edusolutions"  smooth={true} duration={1000}>
                          <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                       </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Our Achivement">
                    <Link to="achivement"  smooth={true} duration={1000}>
                             <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                      </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Available Programs">
                    <Link to="courses"  smooth={true} duration={1000}>
                             <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                      </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Our Teachers">
                    <Link to="teachers"  smooth={true} duration={1000}>
                             <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                        </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Latest Posts">
                         <Link to="blogs"  smooth={true} duration={1000}>
                             <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                        </Link>
                    </Tooltip>
                 </li>
                 <li className="indicator-li">
                    <Tooltip placement="left" title="Footer">
                    <Link to="footer"  smooth={true} duration={1000}>
                             <span><i class="fa fa-square" id="sqr-icon" aria-hidden="true"></i></span>
                        </Link>
                    </Tooltip>
                 </li>
                 
             </ul>
        </div>
        </div>
    )
}

export default Indicator;
